import { render } from "./OrderDetailPage.vue?vue&type=template&id=e29bbc46"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__